import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from '@sainsburys-tech/bolt';
import { ChevronIcon } from '@sainsburys-tech/bolt-icons';
import ClickAndCollect from '../ClickAndCollect/ClickAndCollect';
import ProductAvailability from '../ProductAvailability/ProductAvailability';
import * as Styled from './AvailabilityResult.styles';
var PROP_TYPES = {
  store: PropTypes.object.isRequired,
  storeDistance: PropTypes.string.isRequired,
  availability: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  products: PropTypes.array,
  toggleActiveStore: PropTypes.func,
  selectStoreCallback: PropTypes.func,
  showExpand: PropTypes.bool,
  ctaAddToTrolley: PropTypes.func,
  searchTerm: PropTypes.string,
  isMoreAvailabilityResult: PropTypes.bool,
  selectStoreButtonKind: PropTypes.string
};
var DEFAULT_PROPS = {
  isMoreAvailabilityResult: false,
  selectStoreButtonKind: 'primary'
}; // new mandatory AO parameter. It will be prefixed with the value of the "code" property of the nested "analytics" object of the "config" object

var aoSaveParam = '-ss:ss-cc';

var AvailabilityResultDrawer = function AvailabilityResultDrawer(_ref) {
  var products = _ref.products,
      active = _ref.active;
  return /*#__PURE__*/React.createElement(Styled.AvailabilityResultDrawerContent, {
    active: active
  }, /*#__PURE__*/React.createElement(Styled.AvailabilityResultDrawerContentMargin, null, products && /*#__PURE__*/React.createElement(ProductAvailability, {
    products: products
  })));
};

var AvailabilityResultCTAs = function AvailabilityResultCTAs(_ref2) {
  var _ref2$isBasket = _ref2.isBasket,
      isBasket = _ref2$isBasket === void 0 ? false : _ref2$isBasket,
      store = _ref2.store,
      selectStoreCallback = _ref2.selectStoreCallback,
      ctaAddToTrolley = _ref2.ctaAddToTrolley,
      filters = _ref2.filters,
      searchTerm = _ref2.searchTerm,
      expanded = _ref2.expanded,
      selectStoreButtonKind = _ref2.selectStoreButtonKind;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isBasket ? /*#__PURE__*/React.createElement(Styled.AccordionResultCTA, {
    expanded: expanded
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick(event) {
      return selectStoreCallback(event, store, false, null, 'storeOverview', aoSaveParam);
    },
    "data-test": "cta-button-store-select",
    kind: selectStoreButtonKind || DEFAULT_PROPS.selectStoreButtonKind,
    full: true
  }, "Select this store")) : /*#__PURE__*/React.createElement(Styled.ColumnResultCTA, null, /*#__PURE__*/React.createElement("a", {
    onClick: function onClick(event) {
      return selectStoreCallback(event, store, false, null, 'storeOverview', aoSaveParam);
    },
    "data-test": "cta-link"
  }, "Select this store"), ctaAddToTrolley && filters && filters.length > 0 && ctaAddToTrolley(store, searchTerm, 'store-selector-trolley-cta'), /*#__PURE__*/React.createElement("span", null)));
};

var AvailabilityResultStoreDetails = function AvailabilityResultStoreDetails(_ref3) {
  var store = _ref3.store,
      storeDistance = _ref3.storeDistance,
      toggleActiveStore = _ref3.toggleActiveStore;
  return /*#__PURE__*/React.createElement(Styled.AvailabilityResultStoreDetails, null, /*#__PURE__*/React.createElement(Styled.StoreDetailsParagraph, null, store.name), store.clickandcollect && /*#__PURE__*/React.createElement(ClickAndCollect, null), store.alert && /*#__PURE__*/React.createElement(Alert, {
    kind: "error",
    isCloseable: false,
    "data-test": "component-ss-alert"
  }, store.alert), /*#__PURE__*/React.createElement(Styled.StoreAddressParagraph, null, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Address: "), store.location.address, ", ", store.location.postcode), /*#__PURE__*/React.createElement(Styled.StoreDetailsSpaceBetween, null, /*#__PURE__*/React.createElement(Button, {
    kind: "link",
    onClick: function onClick(event) {
      return toggleActiveStore(event, store, true);
    },
    "data-el": "store-selector-result__link--".concat(store.id),
    "data-test": "store-details-link"
  }, "Store map & opening times"), /*#__PURE__*/React.createElement(Styled.StoreDetailsDistance, null, storeDistance, " miles")));
};

function AvailabilityResult(_ref4) {
  var store = _ref4.store,
      storeDistance = _ref4.storeDistance,
      availability = _ref4.availability,
      products = _ref4.products,
      toggleActiveStore = _ref4.toggleActiveStore,
      selectStoreCallback = _ref4.selectStoreCallback,
      showExpand = _ref4.showExpand,
      ctaAddToTrolley = _ref4.ctaAddToTrolley,
      searchTerm = _ref4.searchTerm,
      isMoreAvailabilityResult = _ref4.isMoreAvailabilityResult,
      selectStoreButtonKind = _ref4.selectStoreButtonKind;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var text = availability.text,
      icon = availability.icon,
      filters = availability.filters;
  return /*#__PURE__*/React.createElement(Styled.AvailabilityResultList, {
    active: expanded,
    "data-test": "component-store-selector-store-list-item",
    isMoreAvailabilityResult: isMoreAvailabilityResult
  }, icon && text && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.AvailabilityResultHeadingButton, {
    onClick: function onClick() {
      return setExpanded(!expanded);
    },
    "data-test": "availability-result-heading"
  }, /*#__PURE__*/React.createElement(Styled.AvailabilityResultHeading, null, /*#__PURE__*/React.createElement(Styled.AvailabilityResultHeadingCollect, null, /*#__PURE__*/React.createElement(Styled.StyledAvailabilityIcon, {
    type: icon,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(Styled.AvailabilityResultHeadingCollectTitle, null, text), showExpand && /*#__PURE__*/React.createElement(Styled.AvailabilityResultMessageContainer, null, /*#__PURE__*/React.createElement(Styled.AvailabilityResultHeadingMessage, {
    "data-test": "toggle-availability-drawer"
  }, expanded ? 'Collapse' : 'Expand'), /*#__PURE__*/React.createElement(Styled.AvailabilityResultHeadingChevron, null, /*#__PURE__*/React.createElement(ChevronIcon, {
    width: 16,
    height: 14,
    dir: expanded ? 'up' : 'down'
  }))))), /*#__PURE__*/React.createElement(Styled.AvailabilityResultHeadingDivider, null))), /*#__PURE__*/React.createElement(Styled.AvailabilityResultHeadingBottomHalf, {
    className: "xs-row"
  }, /*#__PURE__*/React.createElement(AvailabilityResultStoreDetails, {
    store: store,
    storeDistance: storeDistance,
    toggleActiveStore: toggleActiveStore
  }), showExpand && /*#__PURE__*/React.createElement(AvailabilityResultDrawer, {
    products: products,
    store: store,
    selectStoreCallback: selectStoreCallback,
    active: expanded
  }), /*#__PURE__*/React.createElement(AvailabilityResultCTAs, {
    store: store,
    isBasket: showExpand,
    expanded: expanded,
    filters: filters,
    searchTerm: searchTerm,
    ctaAddToTrolley: ctaAddToTrolley,
    selectStoreCallback: selectStoreCallback,
    selectStoreButtonKind: selectStoreButtonKind
  })));
}
/* eslint-enable */


AvailabilityResult.propTypes = PROP_TYPES;
AvailabilityResult.defaultProps = DEFAULT_PROPS;
export default AvailabilityResult;